import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
// helpers
import Color from 'color';
// mui
import { Box, Divider, Grid, Typography } from '@mui/material';
import { styled, makeStyles } from '@mui/styles';
// components
import CbButton from '../../../../../components/Buttons/CbButton';
import { withShowable } from '../../../../_global/lib/withShowable';
// utils
import { PubSub } from '../../../../../utils/eventUtils';
import { Checkbox } from '../../../../../components/inputs';
import { getAttestLabelText } from '../../../../customers/renewals/customerRenewalsUtils';
// hooks
import { useQuoteAttestation } from '../../../../customers/renewals/hooks/useQuoteAttestation';

/* dont make changes to the file for things not related to renewal */
const CustomerRenewalAttestSubmit = ({ data = {}, onMovingAhead }: any) => {
  const { push } = useHistory();
  const classes = useStyles();

  // state
  const [disabled, setDisabled] = useState(false);

  // data
  const { effectiveDate, created, product } = data;

  // disabling Attest button any time updates happen to attest
  React.useEffect(() => {
    const disableSubmit = PubSub.subscribe('disable-Submit', (value: any) => {
      setDisabled(value);
    });

    return () => {
      disableSubmit.remove();
    };
    // eslint-disable-next-line
  }, []);

  const handleAttestRedirect = () => {
    if (typeof onMovingAhead === 'function') {
      onMovingAhead();
    }
  };

  const {
    setNoLossAttested,
    noLossAttested,
    handleAttest,
    attesting,
    invalidQuote,
    NoKnownLossIsReq,
  } = useQuoteAttestation({
    quote: data,
    onSignatureInitiatation: handleAttestRedirect,
  });

  return (
    <>
      <Text>
        <span>*</span> are required field(s)
      </Text>

      <MuiGrid item md={12} show={NoKnownLossIsReq}>
        <MuiDivider />
        <h3 className={`contrast-text ${classes.textHeading}`}>
          STATEMENT OF NO KNOWN LOSS
        </h3>
        <MuiCheckbox
          name="noLossAttested"
          checked={noLossAttested}
          label={getAttestLabelText(effectiveDate, created, product)}
          onChange={setNoLossAttested}
        />
      </MuiGrid>

      <Grid item md={12}>
        <MuiDivider />
        <Box display="flex" justifyContent="center">
          <CbButton
            styleName="cancel"
            onClick={() => push('/customer/policies')}
            buttonText="Cancel"
          />
          <CbButton
            loading={attesting}
            disabled={disabled || (NoKnownLossIsReq ? !noLossAttested : false)}
            styleName="primary"
            onClick={handleAttest}
          >
            {invalidQuote ? 'Done' : 'I Attest'}
          </CbButton>
        </Box>

        <MuiTypography variant="body1" className={classes.note} show={disabled}>
          Note: Save the details to attest quote.
        </MuiTypography>
      </Grid>
    </>
  );
};

const MuiTypography = withShowable(Typography);
const MuiGrid = withShowable(Grid);

const MuiCheckbox = styled(Checkbox)(({ theme: { palette } }) => ({
  '&.MuiCheckbox-root': {
    top: 0,
    left: 5,
    marginRight: 5,
    position: 'relative',
    color: palette.common.cowbellBlue,

    '& > *': {
      color: palette.common.cowbellBlue,
      marginLeft: 2,
    },
  },

  '&.Mui-disabled': {
    '& svg': {
      color: `${Color(palette.text.primary).fade(0.5).string()} !important`,
    },
  },

  '&.Mui-checked': {
    '& svg': {
      color: palette.common.cowbellBlue,
    },
  },
}));

const MuiDivider = styled(Divider)(() => ({
  margin: '2rem 0',
}));

const Text = styled('div')(({ theme }) => ({
  fontStyle: 'italic',
  margin: '-1rem 2rem',

  color: theme.palette.primary.contrastText,
  '& span': {
    color: theme.config.colors.ripeTomato,

    fontSize: theme.config.textSizes.primer,
  },
}));

const useStyles = makeStyles(({ config }) => ({
  note: {
    fontStyle: 'italic',
    fontSize: config.textSizes.normal,
    whiteSpace: 'nowrap',
    margin: '1rem',
    color: config.colors.cowbellBlue,
    textAlign: 'center',
  },
  textHeading: {
    fontWeight: config.weights.bold,
    lineHeight: 1.38,
    marginTop: 0,
  },
}));

export default CustomerRenewalAttestSubmit;
